var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.visible),expression:"visible"}],staticClass:"tipbg",on:{"click":_vm.close}},[_c('div',{staticClass:"tipBox"},[_c('img',{attrs:{"src":_vm.status[_vm.type]?_vm.status[_vm.type]:_vm.status['confirm'],"alt":""}}),_c('span',[_vm._v(_vm._s(_vm.title))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }